import urlsService, { Target } from '@/services/urls-service';
import { appInsights } from '@/telemetry/client';
import { api } from './api-service';

interface IVatNumberRequest {
  vatRegistrationNr: string;
}

interface IVatNumberResponse {
  valid: boolean;
  vatRegistrationNr: string;
  companyName: string;
  address: IAddress;
}

interface ICocNumberLookup {
  registrationNr: string;
}

interface ICompanyAddress {
  straatnaam: string;
  huisnummer: string;
  postcode: string;
  plaats: string;
}

interface IEmbeddedData {
  hoofdvestiging: {
    adressen: ICompanyAddress[];
  };
}

interface ICocNumberLookupResponse {
  naam: string;
  kvkNummer: string;
  actief: boolean;
  _embedded: IEmbeddedData;
}

export const vatNumberLookup = async ({ vatRegistrationNr }: IVatNumberRequest) =>
  api.get<IVatNumberResponse>({
    url: `${urlsService.getUrl('/vat')}?vatNumber=${vatRegistrationNr}`
  });

export const cocNumberLookup = async ({ registrationNr }: ICocNumberLookup) => {
  if (!registrationNr) {
    console.log('no registrationNr');
    return;
  }

  try {
    const url = urlsService.getUrl('kvk-check', { forceClient: true, target: Target.Next, queryParams: { kvknummer: registrationNr } });

    const data = await api.get<ICocNumberLookupResponse>({ url });

    if (data) {
      //  eslint-disable-next-line no-underscore-dangle
      const companyData = data._embedded.hoofdvestiging.adressen[0];
      return {
        companyName: data.naam,
        postalCode: companyData.postcode,
        houseNumber: companyData.huisnummer,
        city: companyData.plaats,
        street: companyData.straatnaam
      };
    }
  } catch (error) {
    console.log(error);
    appInsights.trackException({ exception: new Error(error as any) });
  }
};
